import { render } from "./RequisiteGroupForm.vue?vue&type=template&id=288cb6b6&ts=true"
import script from "./RequisiteGroupForm.vue?vue&type=script&lang=ts"
export * from "./RequisiteGroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__